import { DATA_SOURCE_PREFIX } from 'src/templates/queries/iris';

export const getDataSourceNameFromUri = (uri: string) =>
  uri.split(DATA_SOURCE_PREFIX)[1] || '';
